import { getModule } from 'vuex-module-decorators'
import SystemtModule from '@/store/SystemModule'
import MediaProperty from '@/models/MediaProperty'

const { user } = getModule(SystemtModule)

export default [
  {
    key: 'checkbox',
    label: '',
    sortable: false,
    show: true,
    type: 'checkbox',
  },
  {
    key: 'id',
    label: 'ID',
    sortable: true,
    show: false,
    tdClass: 'align-middle',
  },
  {
    key: 'name',
    label: 'Name',
    sortable: true,
    show: true,
    tdClass: 'align-middle',
  },
  {
    key: 'group_name',
    label: 'Group Name',
    sortable: true,
    show: true,
    tdClass: 'align-middle',
  },
  {
    key: 'has_logo',
    label: 'Logo',
    sortable: false,
    show: true,
    type: 'badge',
    formatter: (value: boolean) => (value ? 'Yes' : 'No'),
    color: (media_package: MediaProperty) => (media_package.has_logo ? 'info' : 'danger'),
    tdClass: 'align-middle text-center',
  },
  {
    key: 'created_at',
    label: 'Created At',
    sortable: true,
    show: false,
    type: 'date',
    tdClass: 'align-middle text-center',
  },
  {
    key: 'updated_at',
    label: 'Update At',
    sortable: true,
    show: true,
    type: 'date',
    tdClass: 'align-middle text-center',
  },
  {
    key: 'action',
    label: 'Actions',
    sortable: false,
    show: true,
    type: 'action_list',
    actions: [
      {
        icon: 'pencil',
        title: 'Edit',
        event: 'edit',
        top_level: true,
        show: () => user && user.can('media_property', 'edit'),
      },
    ],
  },
]
